import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconHorizonFolderGreenSizeS from './IconHorizonFolderGreen_size_s';

const props: CreateIconArguments = {
  l: IconHorizonFolderGreenSizeS,
  m: IconHorizonFolderGreenSizeS,
  s: IconHorizonFolderGreenSizeS,
  xs: IconHorizonFolderGreenSizeS,
  name: 'IconHorizonFolderGreen',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
